import React from "react"
import { SplideSlide as BaseSplideSlide } from "@splidejs/react-splide"
import { styled } from "@mui/material"

const SplideSlide = styled(BaseSplideSlide)(() => ({}))

export const CarouselItem = ({ children, ...props }) => (
  <SplideSlide {...props}>{children}</SplideSlide>
)
